import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './store-notices-app';

const container = document.getElementById('awd-component-root');
const root = container ? createRoot(container) : null;

//*  
if (root) {
    root.render(
        <React.StrictMode>
            <App />
        </React.StrictMode>,
    );
}
/*/
class IntegrationTestComponent extends React.Component {
    render() {
        return <div>WordPress and React integration success!</div>;
    }
}
if (root) {
    root.render(
        <React.StrictMode>
            <IntegrationTestComponent />
        </React.StrictMode>,
    );
}
// */

